export default __webpack_public_path__ + "static/media/03-3D-Face.4ddf3a38.jpg";